import { Injectable } from '@angular/core';
import { ModelViewerElement, RGBA } from '@google/model-viewer';
import { PrimitiveNode } from '@google/model-viewer/lib/features/scene-graph/nodes/primitive-node';
import { AlphaMode } from '@google/model-viewer/lib/three-components/gltf-instance/gltf-2.0';

export class Material2 {
  name: string;
  color: RGBA;
  alphaMode: AlphaMode;
  materialOrigin: any;

  texture: any;
  constructor(
    name: string,
    color: RGBA,
    alphaMode: AlphaMode,
    materialOrigin: any
  ) {
    this.name = name;
    this.color = color;
    this.alphaMode = alphaMode;
    this.materialOrigin = materialOrigin;
  }
}

@Injectable({
  providedIn: 'root',
})
export class ModelViewerArtefactoService {
  private modelViewerInstance?: ModelViewerElement;

  private hierarchy?: PrimitiveNode[];

  private oldMaterials: Material2[] = [];

  constructor() {}

  setModelViewerInstance(modelViewerInstance?: ModelViewerElement) {
    this.modelViewerInstance = modelViewerInstance;
    return this.modelViewerInstance;
  }

  activateAr() {
    return this.modelViewerInstance?.activateAR();
  }

  enableTexture(textureName: string, state = true) {
    console.debug(
      `[Model-Viewer-Artefacto] Set material visibility "${textureName}" to`,
      !!state
    );
    if (!this.modelViewerInstance) {
      throw new Error(
        '[Model-Viewer-Artefacto] ModelViewerInstance is not set'
      );
    }

    // Keep local hierarchy for avoiding to search it each time
    if (!this.hierarchy && this.modelViewerInstance?.model) {
      const model = this.modelViewerInstance?.model as any;
      const sym = Object.getOwnPropertySymbols(model).find(
        (s) => s.description === 'hierarchy'
      );
      if (sym) {
        this.hierarchy = model[sym];
        console.log('Hierarchy found', this.hierarchy);
      } else {
        console.error(`Unable to find sym hierarchy`);
      }
    }

    const materielIndex = this.modelViewerInstance?.model?.materials?.findIndex(
      (material) => {
        const regex = new RegExp(textureName);
        return regex.exec(material.name);
      }
    );

    console.log(materielIndex);

    const nodes = this.hierarchy?.filter((node) => {
      return node['activeMaterialIdx'] === materielIndex;
    });

    console.log('nodes founds with this materiel', nodes);

    nodes?.forEach((node) => {
      node['mesh'].visible = state;
    });
  }

  async applyVariant(variantName: string | null) {
    if (!this.modelViewerInstance) {
      throw new Error(
        '[Model-Viewer-Artefacto] ModelViewerInstance is not set'
      );
    }
    if (variantName !== null && variantName !== undefined) {
      this.modelViewerInstance.variantName = variantName;
    }
  }

  async applyColorOnMaterial(
    textureName: string,
    r: number,
    g: number,
    b: number
  ) {
    console.debug(
      `[Model-Viewer-Artefacto] Apply color on material "${textureName}"`,
      r,
      g,
      b
    );

    let materials = this.modelViewerInstance?.model?.materials;

    // Apply color on wanted material
    materials?.forEach((material) => {
      const regex = new RegExp(textureName);
      if (regex.exec(material.name)) {
        material.pbrMetallicRoughness.setBaseColorFactor([
          r / 255,
          g / 255,
          b / 255,
          1,
        ]);
        material.setAlphaMode('OPAQUE');
      }
    });
  }

  async applyTextureOnMaterial(textureName: string, blob?: Blob) {
    console.debug(
      `[Model-Viewer-Artefacto] Apply texture on material "${textureName}"`,
      blob
    );
    if (!this.modelViewerInstance) {
      throw new Error(
        '[Model-Viewer-Artefacto] ModelViewerInstance is not set'
      );
    }

    let materials = this.modelViewerInstance?.model?.materials;

    // Apply color on wanted material
    if (blob) {
      const file = URL.createObjectURL(blob);
      const texture = await this.modelViewerInstance?.createTexture(file);
      materials?.forEach((material: any) => {
        const regex = new RegExp(textureName);
        if (regex.exec(material.name)) {
          const { baseColorTexture } = material.pbrMetallicRoughness;
          baseColorTexture.setTexture(texture);
        }
      });
    } else {
      materials?.forEach((material: any) => {
        const regex = new RegExp(textureName);
        if (regex.exec(material.name)) {
          const { baseColorTexture } = material.pbrMetallicRoughness;
          baseColorTexture.setTexture(null);
        }
      });
    }
  }

  async resetMaterial(textureName: string, forceCleanTexture = false) {
    console.debug(`[Model-Viewer-Artefacto] Reset material "${textureName}"`);
    if (!this.modelViewerInstance) {
      throw new Error(
        '[Model-Viewer-Artefacto] ModelViewerInstance is not set'
      );
    }

    let oldMaterial = this.oldMaterials.find((m) => m.name === textureName);
    if (!oldMaterial) {
      //throw new Error('[Model-Viewer-Artefacto] Old material is missing, skip');
    }

    let materials = this.modelViewerInstance?.model?.materials;

    // Skip if not found
    if (!materials) {
      return;
    }

    // Apply color on wanted material
    for (let index = 0; index < materials.length; index++) {
      const regex = new RegExp(textureName);
      if (regex.exec(materials[index].name)) {
        if (oldMaterial) {
          materials[index] = oldMaterial.materialOrigin;
        }

        // Reset texture only if requested
        const { baseColorTexture } = materials[index].pbrMetallicRoughness;
        if (forceCleanTexture) {
          baseColorTexture.setTexture(null);
        }
      }
    }
  }
}
